import React from 'react'

const SvgCrossOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 4c0-2.191 1.623-2 2.97-2h.032C13.433 2 15 1.809 15 4v2h3c2.155 0 1.901 2 1.901 3.001S20.155 12 18 12h-3v8c0 2.154-2.343 1.797-2.998 1.802C11.347 21.807 9 22.15 9 20v-8H6c-2.112 0-1.901-1.994-1.901-2.999v-.097C4.084 7.874 3.905 6 6 6h3V4zm4 0h-1.999L11 8H6v2h5v10h2V10h5V8h-5V4z'
    />
  </svg>
)

export default SvgCrossOutline
